import { Form, FormField } from "@/components/ui";
import { useAppDispatch, useAppSelector } from "@/config/store";
import { IEdoFile, defaultValue } from "@/shared/model/edo-file.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui";
import "moment/locale/it";
import { useEffect, useState } from "react";
import { Translate, translate } from "react-jhipster";
import { z } from "zod";
import {
  partialUpdateEntity as partialUpdateFile,
} from "../../../../shared/reducers/entities/edo-file.reducer";

const schema = z.object({
  originalFileName: z.string(),
});

type FormValues = z.infer<typeof schema>;

interface IEditFileProps {
  file?: IEdoFile;
  open: boolean;
  onClose: () => void;
}

const EditFile = (props: IEditFileProps) => {
  const dispatch = useAppDispatch();
  const { loading, updating, updateSuccess } = useAppSelector<
    EntityState<IEdoFile>
  >((state) => state.edoFile);
  const [form, setForm] = useState<IEdoFile>({ ...defaultValue, ...props.file });

  const { file, open, onClose: handleClose } = props;

  useEffect(() => {
    setForm({ ...defaultValue, ...file });
  }, [file]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
      setForm({ ...defaultValue });
    }
  }, [updateSuccess]);

  const saveEntity = (data: FormValues) => {
    dispatch(
      partialUpdateFile({ ...form, originalFileName: data.originalFileName })
    );
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>
            {translate("edocendoApp.edoFile.home.editLabel")}
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)] mb-4">
          Modifica le informazioni del file.
        </p>
        {loading || !file ? (
          <div className="flex justify-center py-4">
            <span className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          </div>
        ) : (
          <Form<FormValues>
            id="edit-file-form"
            key={`${form.id ?? "new"}-${form.originalFileName ?? ""}`}
            schema={schema}
            onSubmit={saveEntity}
            defaultValues={{ originalFileName: form.originalFileName ?? "" }}
            className="flex grow flex-col gap-4"
          >
            <FormField
              name="originalFileName"
              label={translate("edocendoApp.edoFile.originalFileName")}
            />
          </Form>
        )}
        <DialogFooter className="gap-2 sm:gap-0">
          <Button type="button" variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button
            type="submit"
            form="edit-file-form"
            disabled={updating}
          >
            {translate("entity.action.save")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditFile;
